import { render, staticRenderFns } from "./EnquiryLog.vue?vue&type=template&id=1c2bd92f&"
import script from "./EnquiryLog.vue?vue&type=script&lang=js&"
export * from "./EnquiryLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports